export default "__VITE_ASSET__oiPrdKll__"